//Login.js
import AuthForm from "../AuthForm"; // Adjust path if needed

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
      <AuthForm />
    </div>
  );
}
